

























import {Component, Prop, Vue} from "vue-property-decorator";
import {DatenschutzFaService} from "@/services/datenschutzfa-service";
import {DatenschutzFa} from "@/models/datenschutzfa-model";
import DatenschutzFa1Verarbeitungstaetigkeit
    from "@/views/DatenschutzFa/Tabs/DatenschutzFa1Verarbeitungstaetigkeit.vue";
import DatenschutzFa2BewertungVerhaeltnismaessigkeit
    from "@/views/DatenschutzFa/Tabs/DatenschutzFa2BewertungVerhaeltnismaessigkeit.vue";
import DatenschutzFa3Einbeziehnung from "@/views/DatenschutzFa/Tabs/DatenschutzFa3Einbeziehnung.vue";
import DatenschutzFa4Risikobewertung from "@/views/DatenschutzFa/Tabs/DatenschutzFa4Risikobewertung.vue";
import DatenschutzFa5Abhilfemassnahmen from "@/views/DatenschutzFa/Tabs/DatenschutzFa5Abhilfemassnahmen.vue";
import DatenschutzFa6Gesamtabwaegung from "@/views/DatenschutzFa/Tabs/DatenschutzFa6Gesamtabwaegung.vue";
import DatenschutzFa7Dokumente from "@/views/DatenschutzFa/Tabs/DatenschutzFa7Dokumente.vue";

@Component({components: {
        DatenschutzFa7Dokumente,
        DatenschutzFa6Gesamtabwaegung,
        DatenschutzFa5Abhilfemassnahmen,
        DatenschutzFa4Risikobewertung,
        DatenschutzFa3Einbeziehnung,
        DatenschutzFa1Verarbeitungstaetigkeit,
        DatenschutzFa2BewertungVerhaeltnismaessigkeit
    }})
export default class DatenschutzFaGesamtansicht extends Vue {
    protected datenschutzFa: DatenschutzFa = new DatenschutzFa();
    protected service!: DatenschutzFaService;
    public dataLoaded: boolean =false;
    @Prop() id!: number;

    created() {
        this.service = new DatenschutzFaService();
    }

    async mounted(){
        this.datenschutzFa = await this.service.GetById(this.id);
        await this.$nextTick();
        this.dataLoaded = true;
    }
}
